export const plovdivTranslations = {
  en: {
    breadcrumb: { home: 'Home', locations: 'Locations', plovdiv: 'Plovdiv' },
    hero: {
      badge: 'Plovdiv',
      heading: 'Plovdiv Aquatic Center',
      subheading: 'Olympic Swimming Pool & Aquatic Sports Training Facility',
      swimming: 'Swimming',
      waterPolo: 'Water Polo',
      locationInfo: 'Plovdiv, Bulgaria',
      spectatorSeating: 'Spectator seating available',
      sportsList: 'Swimming, Water Polo',
      stars: '5/5 stars',
      bookFacility: 'Book This Facility',
    },
    overview: {
      heading: 'Facility Overview',
      cards: [
        { heading: 'Pool Type', content: 'Olympic Swimming Pool', subtext: '50m x 25m with 10 lanes' },
        { heading: 'Capacity', content: 'Spectator Seating', subtext: 'Professional viewing areas' },
        { heading: 'Water System', content: 'Olympic Standard Filtration', subtext: 'Temperature controlled' },
        { heading: 'Certification', content: 'FINA Standard', subtext: 'Meets international requirements' },
      ],
    },
    about: {
      heading: 'About Plovdiv Aquatic Center',
      description: "A modern aquatic sports center featuring a 50m Olympic swimming pool with 10 lanes—ideal for swimming and water-sports training camps. Located in Plovdiv, Bulgaria's second-largest city, this state-of-the-art facility provides world-class aquatic training environments for competitive swimmers and water polo teams.",
      keyHighlights: 'Key Highlights',
      highlights: [
        '50m Olympic swimming pool with 10 lanes (FINA standard)',
        'Separate training pool for skill development',
        'Temperature-controlled water for optimal training conditions',
        'Olympic-standard filtration and water quality systems',
        'Electronic timing systems for accurate race results',
        'Modern locker rooms with showers and changing facilities',
        'Video analysis room for performance review',
        'Recovery facilities with ice baths and sauna',
        'Ideal for training camps, competitions, and elite athlete development',
      ],
      testimonial: '"A premier aquatic facility with Olympic-standard pools, perfect for elite swimming training and international competitions."',
      testimonialAttribution: 'Champion Maker Team',
    },
    sports: {
      heading: 'Available Sports & Activities',
      swimming: 'Swimming',
      swimmingDesc: 'Professional 50m Olympic swimming pool with 10 lanes, temperature-controlled water, and electronic timing systems meeting FINA standards.',
      viewSpecs: 'View Specifications',
      hideSpecs: 'Hide Specifications',
      poolSpecs: 'Pool Specifications:',
      poolSpecsList: ['Pool dimensions: 50m x 25m (Olympic standard)', 'Lanes: 10 lanes', 'Depth: Variable depth for all strokes', 'Water temperature: Controlled (26-28°C)', 'Filtration: Olympic-standard system', 'Timing: Electronic timing systems'],
      idealFor: 'Ideal For:',
      swimmingIdealFor: ['Elite swimmer training camps', 'National team preparations', 'International competitions', 'All swimming strokes (freestyle, backstroke, breaststroke, butterfly)', 'Relay training and competitions', 'Long-distance swimming training'],
      waterPolo: 'Water Polo',
      waterPoloDesc: 'Dedicated training facilities for water polo teams, with optimal depth and safety features for competitive training and matches.',
      facilitiesAvailable: 'Facilities Available:',
      waterPoloFacilitiesList: ['Water polo training areas', 'Training pool for skill development', 'All areas meet FINA competition standards', 'Professional safety equipment', 'Appropriate depth for water polo training'],
      waterPoloIdealFor: ['Water polo team training camps', 'Technical skill development', 'Competition preparation', 'Year-round aquatic training programs', 'Multi-discipline aquatic sports camps'],
    },
    amenities: {
      heading: 'World-Class Facilities & Amenities',
      items: [
        { title: 'Modern Locker Rooms', desc: 'Spacious changing facilities with showers, lockers, and benches' },
        { title: 'Equipment Storage', desc: 'Secure storage areas for aquatic sports equipment and personal belongings' },
        { title: 'Spectator Seating', desc: 'Comfortable seating for spectators with excellent pool views' },
        { title: 'Parking Available', desc: 'Convenient parking facilities for teams and visitors' },
        { title: 'Equipment Rental', desc: 'Swimming and water polo equipment available for rent' },
        { title: 'WiFi Available', desc: 'High-speed wireless internet throughout the facility' },
        { title: 'Cafeteria Services', desc: 'On-site refreshments and meal options available' },
        { title: 'Recovery Facilities', desc: 'Ice baths, sauna, and physiotherapy areas for athlete recovery' },
        { title: 'Video Analysis Room', desc: 'Professional video analysis equipment for performance review' },
        { title: 'Electronic Timing Systems', desc: 'Professional timing equipment for accurate race results' },
        { title: 'Professional Lighting', desc: 'LED lighting system optimized for training and competitions' },
        { title: 'Climate Control', desc: 'Optimal air temperature and humidity for aquatic training' },
      ],
    },
    galleryImages: { heading: 'Facility Gallery Images' },
    access: {
      heading: 'Location & How to Get Here',
      address: 'Address',
      addressLine1: 'Plovdiv Aquatic Center',
      addressLine2: 'Plovdiv',
      addressLine3: 'Bulgaria',
      getDirections: 'Get Directions',
      byCar: 'By Car',
      car1: 'Parking available on-site',
      car2: 'Easy access from main roads',
      car3: 'Located in Plovdiv city center',
      byBus: 'By Public Transport',
      bus1: 'Bus lines available throughout Plovdiv',
      bus2: 'Tram lines available',
      bus3: 'Well-connected public transport network',
      fromAirports: 'From Airports',
      airport1: 'Plovdiv Airport: 15 km (20-25 min by car)',
      airport2: 'Sofia Airport: 120 km (1.5-2 hours by car)',
      airport3: 'We provide airport transfer services',
      nearbyLandmarks: 'Nearby Landmarks',
      nearby1: 'Plovdiv Old Town - 10 min drive',
      nearby2: 'City center - 5 min drive',
    },
    pricing: {
      heading: 'Pricing & Availability',
      flexiblePricing: 'Flexible Pricing Options',
      pricingVaries: 'Pricing varies based on:',
      factors: [
        'Duration of booking (hourly, half-day, full-day)',
        'Season and demand',
        'Pool access needed (main pool, training pool)',
        'Additional services required',
        'Equipment rental needs',
        'Support staff requirements',
      ],
      pricingNote: 'For detailed pricing and package options, please contact us with your specific requirements.',
      whatsIncluded: "What's Included:",
      included: [
        'Pool access for specified time',
        'Basic equipment (kickboards, pull buoys)',
        'Locker room facilities',
        'Electronic timing systems',
        'Water quality maintenance',
        'On-site staff support',
      ],
      optionalAddons: 'Optional Add-ons:',
      addons: [
        'Equipment rental (fins, paddles, specialized gear)',
        'Extended hours',
        'Video analysis services',
        'Professional coaching',
        'Recovery facility access',
        'Medical support and physiotherapy',
      ],
      requestQuote: 'Request a Quote',
    },
    testimonials: {
      heading: 'What Teams Say About Training Here',
      items: [
        { quote: "The Plovdiv Aquatic Center provided exceptional facilities for our swimming training camp. The 50m Olympic pool is world-class and the temperature control is perfect for competitive training.", name: "Coach Maria Petrova", date: "September 2025" },
        { quote: "Outstanding aquatic facility with Olympic-standard pools. Our water polo team had an excellent training experience. The training facilities are top-notch.", name: "Coach James Wilson", date: "August 2025" },
        { quote: "Perfect venue for elite swimming training camps. The 10-lane pool and electronic timing systems are excellent. Highly recommended for serious competitive swimmers.", name: "Coach Anna Schmidt", date: "July 2025" },
        { quote: "The modern facilities and professional support made our training camp a huge success. The video analysis room and recovery facilities are excellent additions.", name: "Coach David Brown", date: "June 2025" },
      ],
    },
    similar: {
      heading: 'Explore Other Locations',
      viewDetails: 'View Details',
      locations: [
        { name: 'Sofia, Mladost', location: 'Sofia, Mladost', badge: 'Basketball & Volleyball', description: 'Modern basketball and volleyball training facility', path: '/locations/sofia-mladost' },
        { name: 'National Sports Academy', location: 'Sofia, NSA', badge: 'Athletics', description: 'World-class athletics and track & field facilities', path: '/locations/sofia-nsa' },
        { name: 'Boyana Sports Complex', location: 'Sofia, Boyana', badge: 'Multi-Sport', description: 'Comprehensive multi-sport training facility', path: '/locations/sofia-boyana' },
      ],
    },
    faq: {
      heading: 'Frequently Asked Questions',
      items: [
        { question: 'What are the pool specifications?', answer: 'The facility features a 50m x 25m Olympic swimming pool with 10 lanes, temperature-controlled water, and Olympic-standard filtration systems meeting FINA requirements.' },
        { question: 'What aquatic sports are available?', answer: 'The center supports swimming and water polo. There is a separate training pool in addition to the main Olympic pool.' },
        { question: 'Is equipment provided?', answer: 'Basic equipment is available. Additional equipment such as training aids, kickboards, pull buoys, and specialized gear can be rented separately.' },
        { question: 'What are the facility operating hours?', answer: 'The facility operates from 6:00 AM to 10:00 PM daily. Extended hours can be arranged for training camps and competitions upon request.' },
        { question: 'Is there accommodation on-site?', answer: 'Accommodation is not available on-site at this location, but we can arrange lodging at nearby 4-star hotels in Plovdiv city center.' },
        { question: 'How far is it from Plovdiv Airport?', answer: 'The Plovdiv Aquatic Center is approximately 15 km from Plovdiv Airport, about 20-25 minutes by car. We also provide transfer services from Sofia Airport (120 km away).' },
        { question: 'Can we host competitions here?', answer: 'Absolutely! The facility is equipped for hosting swimming competitions and meets with spectator seating, electronic timing systems, and all necessary equipment.' },
        { question: 'What video analysis facilities are available?', answer: 'The center features a dedicated video analysis room with professional equipment for underwater and above-water filming and performance analysis.' },
        { question: 'Is the facility accessible for people with disabilities?', answer: 'Yes, the facility is wheelchair accessible with appropriate facilities for athletes and spectators with disabilities, including accessible pool access.' },
        { question: 'Are recovery facilities available?', answer: 'Yes, the facility includes recovery facilities with ice baths, sauna, and physiotherapy areas to support athlete recovery and performance.' },
      ],
    },
    cta: {
      heading: 'Ready to Book Plovdiv Aquatic Center?',
      subheading: 'Contact us to reserve your training dates',
      sendInquiry: 'Send a quick inquiry',
      requestInfo: 'Request Information',
      speakWithTeam: 'Speak with our team',
      getCompletePackage: 'Get a complete package',
      bookCompletePackage: 'Book Complete Package',
      ctaCallNow: 'Call Now',
    },
  },
  ar: {
    breadcrumb: { home: 'الرئيسية', locations: 'المواقع', plovdiv: 'بلوفديف' },
    hero: {
      badge: 'بلوفديف',
      heading: 'مركز بلوفديف المائي',
      subheading: 'مسبح أولمبي ومركز تدريب الرياضات المائية',
      swimming: 'السباحة',
      waterPolo: 'كرة الماء',
      locationInfo: 'بلوفديف، بلغاريا',
      spectatorSeating: 'مقاعد للمتفرجين متاحة',
      sportsList: 'السباحة، كرة الماء',
      stars: '5/5 نجوم',
      bookFacility: 'احجز هذه المنشأة',
    },
    overview: {
      heading: 'نظرة عامة على المنشأة',
      cards: [
        { heading: 'نوع المسبح', content: 'مسبح سباحة أولمبي', subtext: '50م × 25م مع 10 حارات' },
        { heading: 'السعة', content: 'مقاعد للمتفرجين', subtext: 'مناطق مشاهدة احترافية' },
        { heading: 'نظام المياه', content: 'ترشيح بأبعاد أولمبية', subtext: 'درجة حرارة مضبوطة' },
        { heading: 'الشهادة', content: 'معيار فينا', subtext: 'يلبي المتطلبات الدولية' },
      ],
    },
    about: {
      heading: 'عن مركز بلوفديف المائي',
      description: 'مركز رياضي مائي حديث يضم مسبحاً أولمبياً طوله 50 متراً و10 حارات — مثالي لمعسكرات تدريب السباحة والرياضات المائية. يقع في بلوفديف، ثاني أكبر مدينة في بلغاريا، وتوفر هذه المنشأة الحديثة بيئات تدريب مائية عالمية المستوى للسباحين التنافسيين وفرق كرة الماء.',
      keyHighlights: 'أبرز المميزات',
      highlights: [
        'مسبح سباحة أولمبي 50م مع 10 حارات (معيار فينا)',
        'مسبح تدريب منفصل لتطوير المهارات',
        'مياه بدرجة حرارة مضبوطة لظروف تدريب مثالية',
        'أنظمة ترشيح وجودة مياه بأبعاد أولمبية',
        'أنظمة توقيت إلكترونية لنتائج سباق دقيقة',
        'غرف خلع ملابس حديثة مع دوش ومرافق تغيير',
        'غرفة تحليل فيديو لمراجعة الأداء',
        'مرافق تعافي مع أحواض ثلج وساونا',
        'مثالي لمعسكرات التدريب والمسابقات وتطوير الرياضيين النخبة',
      ],
      testimonial: '"منشأة مائية رائدة بمسابح بأبعاد أولمبية، مثالية لتدريب السباحة النخبة والمسابقات الدولية."',
      testimonialAttribution: 'فريق صناع الأبطال',
    },
    sports: {
      heading: 'الرياضات والأنشطة المتاحة',
      swimming: 'السباحة',
      swimmingDesc: 'مسبح سباحة أولمبي احترافي 50م مع 10 حارات، مياه بدرجة حرارة مضبوطة وأنظمة توقيت إلكترونية تلبي معايير فينا.',
      viewSpecs: 'عرض المواصفات',
      hideSpecs: 'إخفاء المواصفات',
      poolSpecs: 'مواصفات المسبح:',
      poolSpecsList: ['أبعاد المسبح: 50م × 25م (معيار أولمبي)', 'حارات: 10 حارات', 'العمق: عمق متغير لجميع الأساليب', 'درجة حرارة الماء: مضبوطة (26-28°م)', 'الترشيح: نظام بأبعاد أولمبية', 'التوقيت: أنظمة توقيت إلكترونية'],
      idealFor: 'مثالي لـ:',
      swimmingIdealFor: ['معسكرات تدريب سباحين نخبة', 'تحضيرات المنتخبات الوطنية', 'مسابقات دولية', 'جميع أساليب السباحة (حرة، ظهر، صدر، فراشة)', 'تدريب ومسابقات التتابع', 'تدريب السباحة لمسافات طويلة'],
      waterPolo: 'كرة الماء',
      waterPoloDesc: 'مرافق تدريب مخصصة لفرق كرة الماء، بعمق مثالي وميزات أمان للتدريب والمواجهات التنافسية.',
      facilitiesAvailable: 'المرافق المتاحة:',
      waterPoloFacilitiesList: ['مناطق تدريب كرة الماء', 'مسبح تدريب لتطوير المهارات', 'جميع المناطق تلبي معايير مسابقات فينا', 'معدات أمان احترافية', 'عمق مناسب لتدريب كرة الماء'],
      waterPoloIdealFor: ['معسكرات تدريب فرق كرة الماء', 'تطوير المهارات التقنية', 'التحضير للمسابقات', 'برامج تدريب مائي على مدار العام', 'معسكرات رياضات مائية متعددة التخصصات'],
    },
    amenities: {
      heading: 'مرافق وخدمات عالمية المستوى',
      items: [
        { title: 'غرف خلع ملابس حديثة', desc: 'مرافق تغيير واسعة مع دوش وخزائن ومقاعد' },
        { title: 'تخزين المعدات', desc: 'مناطق تخزين آمنة لمعدات الرياضات المائية والممتلكات الشخصية' },
        { title: 'مقاعد للمتفرجين', desc: 'مقاعد مريحة للمتفرجين مع إطلالات ممتازة على المسبح' },
        { title: 'موقف سيارات متاح', desc: 'مرافق انتظار مريحة للفرق والزوار' },
        { title: 'تأجير المعدات', desc: 'معدات سباحة وكرة ماء متاحة للتأجير' },
        { title: 'واي فاي متاح', desc: 'إنترنت لاسلكي عالي السرعة في جميع أنحاء المنشأة' },
        { title: 'خدمات كافيتريا', desc: 'مرطبات ووجبات متاحة في الموقع' },
        { title: 'مرافق تعافي', desc: 'أحواض ثلج وساونا ومناطق علاج فيزيائي لتعافي الرياضيين' },
        { title: 'غرفة تحليل فيديو', desc: 'معدات تحليل فيديو احترافية لمراجعة الأداء' },
        { title: 'أنظمة توقيت إلكترونية', desc: 'معدات توقيت احترافية لنتائج سباق دقيقة' },
        { title: 'إضاءة احترافية', desc: 'نظام إضاءة LED محسّن للتدريب والمسابقات' },
        { title: 'التحكم بالمناخ', desc: 'درجة حرارة ورطوبة هواء مثالية للتدريب المائي' },
      ],
    },
    galleryImages: { heading: 'صور معرض المنشأة' },
    access: {
      heading: 'الموقع وكيفية الوصول',
      address: 'العنوان',
      addressLine1: 'مركز بلوفديف المائي',
      addressLine2: 'بلوفديف',
      addressLine3: 'بلغاريا',
      getDirections: 'الحصول على الاتجاهات',
      byCar: 'بالسيارة',
      car1: 'موقف سيارات متاح في الموقع',
      car2: 'وصول سهل من الطرق الرئيسية',
      car3: 'يقع في وسط مدينة بلوفديف',
      byBus: 'بالنقل العام',
      bus1: 'خطوط حافلات متاحة في جميع أنحاء بلوفديف',
      bus2: 'خطوط ترام متاحة',
      bus3: 'شبكة نقل عام مترابطة',
      fromAirports: 'من المطارات',
      airport1: 'مطار بلوفديف: 15 كم (20-25 دقيقة بالسيارة)',
      airport2: 'مطار صوفيا: 120 كم (1.5-2 ساعة بالسيارة)',
      airport3: 'نوفر خدمات نقل من المطار',
      nearbyLandmarks: 'معالم قريبة',
      nearby1: 'البلدة القديمة في بلوفديف - 10 دقائق بالسيارة',
      nearby2: 'وسط المدينة - 5 دقائق بالسيارة',
    },
    pricing: {
      heading: 'الأسعار والتوفر',
      flexiblePricing: 'خيارات أسعار مرنة',
      pricingVaries: 'تختلف الأسعار حسب:',
      factors: [
        'مدة الحجز (بالساعة، نصف يوم، يوم كامل)',
        'الموسم والطلب',
        'وصول المسبح المطلوب (المسبح الرئيسي، مسبح التدريب)',
        'الخدمات الإضافية المطلوبة',
        'احتياجات تأجير المعدات',
        'متطلبات طاقم الدعم',
      ],
      pricingNote: 'للحصول على تفاصيل الأسعار وخيارات الباقات، يرجى الاتصال بنا مع متطلباتك المحددة.',
      whatsIncluded: 'ما الذي يُدرج:',
      included: [
        'وصول للمسبح للوقت المحدد',
        'معدات أساسية (لوحات ركل، عوائم سحب)',
        'مرافق غرف خلع الملابس',
        'أنظمة توقيت إلكترونية',
        'صيانة جودة المياه',
        'دعم الطاقم في الموقع',
      ],
      optionalAddons: 'إضافات اختيارية:',
      addons: [
        'تأجير معدات (زعانف، مجاديف، معدات متخصصة)',
        'ساعات إضافية',
        'خدمات تحليل فيديو',
        'تدريب احترافي',
        'وصول مرافق التعافي',
        'دعم طبي وعلاج فيزيائي',
      ],
      requestQuote: 'طلب عرض أسعار',
    },
    testimonials: {
      heading: 'ماذا تقول الفرق عن التدريب هنا',
      items: [
        { quote: 'وفر مركز بلوفديف المائي مرافق استثنائية لمعسكر تدريب السباحة لدينا. المسبح الأولمبي 50م عالمي المستوى والتحكم في درجة الحرارة مثالي للتدريب التنافسي.', name: 'المدرب ماريا بتروفا', date: 'سبتمبر 2025' },
        { quote: 'منشأة مائية متميزة بمسابح بأبعاد أولمبية. حظي فريق كرة الماء لدينا بتجربة تدريب ممتازة. المرافق التدريبية من الطراز الأول.', name: 'المدرب جيمس ويلسون', date: 'أغسطس 2025' },
        { quote: 'مكان مثالي لمعسكرات تدريب السباحة النخبة. المسبح ذو 10 حارات وأنظمة التوقيت الإلكترونية ممتازة. موصى به بشدة للسباحين التنافسيين الجادين.', name: 'المدرب آنا شميدت', date: 'يوليو 2025' },
        { quote: 'المرافق الحديثة والدعم الاحترافي جعلا معسكر التدريب لدينا نجاحاً كبيراً. غرفة تحليل الفيديو ومرافق التعافي إضافات ممتازة.', name: 'المدرب ديفيد براون', date: 'يونيو 2025' },
      ],
    },
    similar: {
      heading: 'استكشف مواقع أخرى',
      viewDetails: 'عرض التفاصيل',
      locations: [
        { name: 'صوفيا، ملادوست', location: 'صوفيا، ملادوست', badge: 'كرة السلة والطائرة', description: 'منشأة تدريب حديثة لكرة السلة والطائرة', path: '/locations/sofia-mladost' },
        { name: 'الأكاديمية الوطنية للرياضة', location: 'صوفيا، الأكاديمية الوطنية', badge: 'ألعاب القوى', description: 'مرافق ألعاب قوى وجري وميدان عالمية المستوى', path: '/locations/sofia-nsa' },
        { name: 'المجمع الرياضي بويانا', location: 'صوفيا، بويانا', badge: 'متعدد الرياضات', description: 'منشأة تدريب رياضية شاملة', path: '/locations/sofia-boyana' },
      ],
    },
    faq: {
      heading: 'الأسئلة الشائعة',
      items: [
        { question: 'ما مواصفات المسبح؟', answer: 'تضم المنشأة مسبح سباحة أولمبي 50م × 25م مع 10 حارات، مياه بدرجة حرارة مضبوطة، وأنظمة ترشيح بأبعاد أولمبية تلبي متطلبات فينا.' },
        { question: 'ما الرياضات المائية المتاحة؟', answer: 'يدعم المركز السباحة وكرة الماء. يوجد مسبح تدريب منفصل بالإضافة إلى المسبح الأولمبي الرئيسي.' },
        { question: 'هل يتم توفير المعدات؟', answer: 'المعدات الأساسية متاحة. يمكن تأجير معدات إضافية مثل مساعدات التدريب ولوحات الركل وعوائم السحب والمعدات المتخصصة بشكل منفصل.' },
        { question: 'ما ساعات عمل المنشأة؟', answer: 'تعمل المنشأة من 6:00 صباحاً إلى 10:00 مساءً يومياً. يمكن ترتيب ساعات إضافية لمعسكرات التدريب والمسابقات عند الطلب.' },
        { question: 'هل تتوفر إقامة في الموقع؟', answer: 'الإقامة غير متاحة في الموقع بهذا الموقع، لكن يمكننا ترتيب الإقامة في فنادق 4 نجوم قريبة في وسط مدينة بلوفديف.' },
        { question: 'كم تبعد عن مطار بلوفديف؟', answer: 'مركز بلوفديف المائي على بعد حوالي 15 كم من مطار بلوفديف، نحو 20-25 دقيقة بالسيارة. نوفر أيضاً خدمات نقل من مطار صوفيا (120 كم).' },
        { question: 'هل يمكننا تنظيم مسابقات هنا؟', answer: 'بالتأكيد! المنشأة مجهزة لاستضافة مسابقات واجتماعات سباحة مع مقاعد للمتفرجين وأنظمة توقيت إلكترونية وجميع المعدات اللازمة.' },
        { question: 'ما مرافق تحليل الفيديو المتاحة؟', answer: 'يضم المركز غرفة تحليل فيديو مخصصة بمعدات احترافية للتصوير تحت الماء وفوق الماء وتحليل الأداء.' },
        { question: 'هل المنشأة متاحة لذوي الاحتياجات الخاصة؟', answer: 'نعم، المنشأة متاحة للكراسي المتحركة مع مرافق مناسبة للرياضيين والمتفرجين ذوي الاحتياجات الخاصة، بما في ذلك وصول متاح للمسبح.' },
        { question: 'هل تتوفر مرافق تعافي؟', answer: 'نعم، تضم المنشأة مرافق تعافي مع أحواض ثلج وساونا ومناطق علاج فيزيائي لدعم تعافي وأداء الرياضيين.' },
      ],
    },
    cta: {
      heading: 'مستعد لحجز مركز بلوفديف المائي؟',
      subheading: 'اتصل بنا لحجز مواعيد التدريب',
      sendInquiry: 'أرسل استفساراً سريعاً',
      requestInfo: 'طلب معلومات',
      speakWithTeam: 'تحدث مع فريقنا',
      getCompletePackage: 'احصل على باقة كاملة',
      bookCompletePackage: 'احجز الباقة الكاملة',
      ctaCallNow: 'اتصل الآن',
    },
  },
};
